import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, FormControl, NgForm } from '@angular/forms';


@Component({
  selector: 'app-error-handler',
  templateUrl: './error-handler.component.html',
  styleUrls: ['./error-handler.component.less']
})
export class ErrorHandlerComponent implements OnInit {
  @Input()
  control: AbstractControl<any> | null = null;
  @Input()
  submitted: boolean = false;
  @Input()
  errorType: string = '';
  @Input()
  message: string = '';

  showError: boolean = false;
  errorMessage: string = '';

  constructor() { 

  }

  ngOnInit() {
    this.errorMessage = this.message; 

    if(this.message === '')
      this.errorMessage =  this.getErrorMessage();
  }



  getErrorMessage(): string {
    if(this.errorType === 'required' || this.errorType === 'requerido' || this.errorType === 'requiredIf' ||
    this.errorType === 'requiredIfFalse' || this.errorType === 'requiredIfTrue') {
      return 'Esse campo é obrigatório.';
    }

    if(this.errorType === 'pattern') {
      return 'Formato inválido.';
    }

    if(this.errorType === 'requeridoSe') {
      return 'Esse campo é obrigatório.';
    }

    if(this.errorType === 'validCpf') {
      return 'Esse CPF é inválido.';
    }

    if(this.errorType === 'email') {
      return 'Esse e-mail é inválido.';
    }

    if(this.errorType === 'pis') {
      return 'Esse PIS é inválido.';
    }

    if(this.errorType === 'requiridoSeNaoEstagiario') {
      return 'Esse campo é obrigatório para não estagiário.'
    }

    if(this.errorType === 'profissionalRegistro') {
      return 'Esse campo é obrigatório para a formação desse profissional.'
    }

    if(this.errorType === 'profissionalMinistraCursosCpf') {
      return 'Esse campo é obrigatório para esse profissional.'
    }
    
    if(this.errorType === 'senha2IgualSenha1' || this.errorType === 'passwordsAreEquals') {
      return '"Nova Senha" e "Repetir Nova Senha" devem ser iguais.'
    }

    if(this.errorType === 'mudancaDestinoDiferenteOrigem') {
      return 'A lotação/atribuição de origem deve ser diferente da lotação/atribuição destino.'
    }
    
    
    

    if(this.errorType === 'catLocalAcidenteInscricao') {
      return 'Esse campo é obrigatório para o tipo de local de acidente selecionado.'
    }

    if(this.errorType === 'catHorarioAcidente') {
      return 'Formato inválido.'
    }

    if(this.errorType === 'catHorasTrabalhadasAntes') {
      return 'Formato inválido.'
    }




    if(this.errorType === 'atestadoHoraAtendimento') {
      return 'Formato inválido.'
    }

    
    return '';
  }  

}
